import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-slate-800 bg-slate-900/60 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1yeb4ckorj8qr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1anxn7p7puuay">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1aop4rw4hari8">I {totalBonuses} <span className="text-amber-400" data-id="element-21" data-mp="15pw26yqqckwu">Bonus Esclusivi</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-slate-800 bg-slate-950 shadow-lg" data-id="element-22" data-mp="1jgr4ttamy5rz">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-slate-800 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="1eo7tl2zf7mqc" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-slate-700 bg-slate-900 text-sky-400" data-id="element-24" data-mp="2jhcxb26p1m2z">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="2og7q8wydkr0t" />
                </span>
                <div data-id="element-26" data-mp="1qus4dxakl1xb">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-amber-400" data-id="element-27" data-mp="1qvldh4x043im">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-extrabold uppercase leading-tight text-white" data-id="element-28" data-mp="20reqepemtz0x">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-300" data-id="element-29" data-mp="25r11as6zn36k">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-amber-400 bg-slate-950 px-6 py-6 text-center shadow-lg sm:flex-row sm:text-left" data-id="element-30" data-mp="3c8wgim3aj04z">
          <div data-id="element-31" data-mp="1h5i08vfv26kx">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-slate-300" data-id="element-32" data-mp="1c4arat1zf1co">Valore di tutti i {totalBonuses} bonus</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-slate-300 line-through decoration-amber-400 decoration-2" data-id="element-33" data-mp="1q4d8se6dnsre">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-34" data-mp="yce4n4j31jno">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-slate-300" data-id="element-35" data-mp="yd5oxj78buyn">Il tuo prezzo oggi</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-amber-400" data-id="element-36" data-mp="tbq33ox89kf7">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-37" data-mp="1772b2y0e97e2" /> GRATIS
            </p>
          </div>
        </div>
      </div>
    </section>;
}